import { Component } from '@theme/component';

class MarylunaVideoComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const video = this.querySelector('video');
    if (!video) return;
    video.addEventListener('play', this.#sync);
    video.addEventListener('pause', this.#sync);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const video = this.querySelector('video');
    video?.removeEventListener('play', this.#sync);
    video?.removeEventListener('pause', this.#sync);
  }

  toggle() {
    const video = this.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }

  #sync = () => {
    const video = this.querySelector('video');
    const button = this.querySelector('.ml-hero__toggle');
    if (!video || !button) return;
    button.setAttribute('aria-pressed', String(video.paused));
    button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
  };
}

if (!customElements.get('maryluna-video-component')) {
  customElements.define('maryluna-video-component', MarylunaVideoComponent);
}
